import { queryOptions } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { OAuthClientActivation } from '../types'

export const oauthClientActivationQueryKey = (clientId: string) => [
  'oauth-clients',
  clientId,
  'activation'
]

export const oauthClientActivationQueryOptions = (clientId: string) =>
  queryOptions({
    queryKey: oauthClientActivationQueryKey(clientId),
    queryFn: () =>
      fetchApiWithToken<OAuthClientActivation>({
        method: 'get',
        url: `/v1/oauth-clients/${clientId}/activation`,
        showToast: false
      })
  })
